import { render, staticRenderFns } from "./EmailBroadcastPage.vue?vue&type=template&id=6f3b70bb&scoped=true"
import script from "./EmailBroadcastPage.vue?vue&type=script&lang=js"
export * from "./EmailBroadcastPage.vue?vue&type=script&lang=js"
import style0 from "./EmailBroadcastPage.vue?vue&type=style&index=0&id=6f3b70bb&prod&lang=css"
import style1 from "./EmailBroadcastPage.vue?vue&type=style&index=1&id=6f3b70bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3b70bb",
  null
  
)

export default component.exports